import React, { useEffect, useState } from 'react';
import { getLogs } from '@api/resident';
import { ApiResponse, ListApiResponse } from '@typings/ApiResponse';
import { LastedUpdateDateData } from '@typings/ResidentTypes';
import Pagination from '@components/pagination';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

export interface LastUpdatedType {
  id: string;
  fullName: string;
  email: string;
  updatedAt: string;
}

interface DateLastUpdatedProps {
  refreshLogs: boolean;
  userId: string;
}

const DateLastUpdated: React.FC<DateLastUpdatedProps> = ({
  refreshLogs,
  userId,
}) => {
  const [lastUpdatedList, setLastUpdatedList] = useState<LastUpdatedType[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const scrollToId = (location.state as any)?.scrollTo;
    if (scrollToId) {
      setTimeout(() => {
        const el = document.getElementById(scrollToId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        // Clear the scroll state to prevent it from running again
        navigate(location.pathname, { replace: true, state: {} });
      }, 50);
    }
  }, [location, navigate]);

  useEffect(() => {
    const handleGetLogs = async () => {
      if (userId) {
        try {
          const res: ApiResponse<ListApiResponse<LastedUpdateDateData>> =
            await getLogs(userId, currentPage, 5);
          if (res && res.status === 'success') {
            const formatedList = res.data?.data?.map(acti => {
              return {
                id: acti.id,
                fullName: acti.full_name,
                email: acti.email,
                updatedAt: acti.updatedAt,
              };
            });
            setTotalPages(res?.data?.pages);
            setLastUpdatedList([...formatedList]);
          }
        } catch (error) {
          console.error(error);
        }
      }
    };
    handleGetLogs();
  }, [currentPage, userId, refreshLogs]);

  useEffect(() => {
    const scrollToId = (location.state as any)?.scrollTo;
    if (scrollToId) {
      setTimeout(() => {
        const el = document.getElementById(scrollToId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        // Clear the scroll state to prevent it from running again
        navigate(location.pathname, { replace: true, state: {} });
      }, 50);
    }
  }, [location, navigate]);

  return (
    <div className="mt-10 govuk-bp:mt-14" id="dateLastUpdated">
      <h1 className="govuk-heading-l">Date last updated</h1>
      <h3 className="govuk-heading-s">
        This is a record of the date that this About Me section was created or
        last updated.
      </h3>
      <table className="govuk-table">
        <thead className="govuk-table__head">
          <tr className="govuk-table__row">
            <th scope="col" className="govuk-table__header">
              Name of professional
            </th>
            <th scope="col" className="govuk-table__header">
              Time and date
            </th>
          </tr>
        </thead>
        <tbody className="govuk-table__body">
          {lastUpdatedList?.map(acti => {
            return (
              <tr
                className="govuk-table__row"
                key={`${acti.id}-${acti.updatedAt}`}
              >
                <th scope="row" className="govuk-table__header">
                  {acti.fullName}
                </th>
                <td className="govuk-table__cell">
                  {dayjs(new Date(acti.updatedAt)).format(
                    'h:mm:ss A, D MMMM, YYYY'
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
      />
    </div>
  );
};

export default DateLastUpdated;
